var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-text-field',_vm._g(_vm._b({attrs:{"id":"form_address","label":"Your delivery address","label-float":""}},'mu-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }